// Built-in import
import * as React from "react";


import { IEvent } from "@/types/event";
// External import
import { Stack } from "@mui/material";

// internal import
import { TitleWithValue } from "@/components/shared";
import { useTranslation } from "react-i18next";

interface IChildrenStructureTitle {
  cardTitle: string;
  cardMeta?: string;
  cardType?: string;
  children: React.ReactNode;
  event?: IEvent;
}

const ChildrenStructureTitle: React.FC<IChildrenStructureTitle> = ({
  cardTitle,
  cardMeta,
  children,
  cardType
}) => {
  //getting translation object
  const { t } = useTranslation();

  return (
    <Stack
      sx={{
        flexGrow: 1,
        bgcolor: (t) => t.palette.common.white,
        borderRadius: "9px",
        border: "1px solid",
        borderColor: (t) => t.palette.grey[300],
        width: "100%",
        height: "100%",
      }}
      spacing={1}
    >
      <Stack
        sx={{
          px: 1.5,
          py: 0.5,
          borderBottom: cardType !== "Report" && "1px solid",
          borderColor: (t) => t.palette.grey[300],
        }}
      >
        {cardType !== "Report" && <TitleWithValue
          title={cardTitle}
          value={cardMeta}
          hasDoubleDot={false}
          justifyContent="space-between"
          colorTitle="text.secondary"
          colorValue="text.secondary"
          variantTitle="smallMedium"
          variantValue="smallMedium"
        />}
      </Stack>
      <Stack px={1.5} py={0.5}>
        <TitleWithValue
          title={t("title")}
          value={
            null
          }
          direction={"row"}
          justifyContent="space-between"
          colorTitle="text.secondary"
          colorValue="text.secondary"
          variantTitle="smallMedium"
          variantValue="smallMedium"
        />
        {children}
      </Stack>
    </Stack>
  );
};

export default ChildrenStructureTitle;
